import React from 'react';

/**
 * PHP stage header layout:
 * hint (top-right) → title → TIME left | SCORE right → children
 */
export default function StageChrome({ title, score, timerDisplay, hint, children, className = '' }) {
  return (
    <div className={`sop-stage ${className}`}>
      {hint ? <div className="sop-hint-row">{hint}</div> : null}

      {title ? <h4 className="sop-title">{title}</h4> : null}

      <div className="sop-meta-row">
        <div className="sop-timer" id="timer">
          Time: {timerDisplay}
        </div>
        <div className="sop-score" id="scoreid">
          Score : {score}
        </div>
      </div>

      <div className="sop-stage-body">{children}</div>
    </div>
  );
}
